import * as React from "react";

interface ChatContextType {
  handleSendMessage: (message: string) => void;
}

export const ChatContext = React.createContext<ChatContextType | undefined>(
  undefined,
);
